<template>
  <div class="menu-popup__item"
       :class="{'font-medium': active}">
    <span class="icon"
          :class="muteInactive && !active ? 'text-icon' : 'text-icon-active'">
      <slot name="icon"/>
    </span>
    <slot name="text"/>
    <IconRoundTick v-if="active" class="text-icon ml-auto"/>
  </div>
</template>

<script>
import IconRoundTick from "@/components/icons/IconRoundTick";

export default {
  name: "MenuPopupItem",
  components: {IconRoundTick},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    muteInactive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.menu-popup__item {
  @apply text-text text-sm flex items-center pr-4 cursor-pointer transition duration-200;

  .icon {
    @apply flex items-center justify-center bg-transaction-gradient transition duration-200;
    width: 36px;
    height: 36px;
    margin-right: 14px;
  }

  &:hover {
    @apply text-red;
    .icon {
      @apply text-red;
    }
  }
}
</style>